<template>
  <tree-selector class="user-selector" @search="search" @confirm="confirm" @cancel="cancel" @load="load"
                 :root="keyword?search_list:root"
                 :value="value" :options="options">
    <span class="template" slot-scope="slot_data">
      <img v-if="!slot_data.node.childs" class="tree-node-icon" :src="defaultUserIcon"/>
      <span>{{ slot_data.node.name }}</span>
    </span>
  </tree-selector>
</template>

<script>
import {TreeSelector} from "@maidi/libs.pc"
import orgApi from "@/apis/org";

export default {
  name: "org-selector",
  props: {
    multi: {
      type: Boolean,
      default: false
    },
    value: { }
  },
  components: {TreeSelector},
  data() {
    return {
      loading: true,
      keyword: "",
      search_list: [],
      root:  [],
      defaultUserIcon : require("../../../../assets/img/default-user.png"),
      options: {
        multi: this.multi,
        mapping: {treeId: '',children:'childs'},
        selectable(node) {
          return !node.childs;
        }
      }
    };
  },
  methods: {
    async search(keyword) {
      if (this.keyword === keyword) {
        return;
      }
      this.keyword = keyword;
      if (!this.keyword) {
        return;
      }
      this.search_list.length = 0;
      const param = {
        deptId: -1,
        keyWords: this.keyword,
        page: 1,
        pageSize: 100,
      };
      const models = await orgApi.getCompUserList(param);
      if(!models||!models.data.length)return  Message.warn("未找到相关人员");
      const users=models.data;

      const ids = this.search_list.map((user) => user.id);
      this.search_list.push(...users.filter((user) => !ids.includes(user.id)).map(user=>({
        ...user,
        leaf:true,
        name:user.realName
      })));
    },
    async load(node) {
      this.loading = true;
      const dirs = [], models = [];
      node && node.childs && node.childs.forEach((_node) => {
        delete _node.leaf;
        _node.type = node.type;
      });
      if (!node || node.id < 0) {
        const [_dirs, {data:_models}] = await Promise.all([orgApi.getDepartmentTree(0), orgApi.getCompUserList({
          deptId: -1,
          page: 1,
          pageSize: 100,
        })]);
        dirs.push(..._dirs);
        models.push(..._models.filter(item=>!item.departmentList.length));
      }else {
        const {data:_models} = await orgApi.getCompUserList({
          deptId: node.id,
          page: 1,
          pageSize: 100,
        });
        models.push(..._models);
      }
      if (node && !node.childs) {
        this.$set(node, "childs", []);
      }
      dirs.forEach(dir => {
        delete dir.leaf
      });
      models.forEach(model => {
        model.leaf = true;
        model.name=model.realName
      });
      (node ? node.childs : this.root).push(...dirs, ...models);
      (node && node.childs && !node.childs.length) && (node.leaf = true);
      this.loading = false;
    },
    cancel() {
      this.$emit("cancel")
    },

    async confirm(...args) {
      this.$emit("confirm", ...args);
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../assets/css/global";

.content {
  padding: 24px;
  height: 350px;
  width: 600px;

  .icons {
    display: flex;
    flex-wrap: wrap;

    .select-item {
      display: block;
      cursor: pointer;
      border: 1px solid transparent;
      overflow: hidden;
      position: relative;
      text-align: center;
      opacity: 0.5;

      &.active {
        opacity: 1;
      }

      i {
        position: absolute;
        display: block;
        border-radius: 50%;
        bottom: 2px;
        right: 2px;
        color: $color-bg;
        width: 13px;
        height: 13px;
        font-size: 13px;
        text-align: center;
      }
    }
  }
}

.footer {
  padding: 10px 16px;
  text-align: right;
  background: transparent;
  border-top: 1px solid #e8e8e8;
}
</style>
